import { render, staticRenderFns } from "./opinion.vue?vue&type=template&id=4316583c&scoped=true&"
import script from "./opinion.vue?vue&type=script&lang=js&"
export * from "./opinion.vue?vue&type=script&lang=js&"
import style0 from "./opinion.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./opinion.vue?vue&type=style&index=1&id=4316583c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4316583c",
  null
  
)

export default component.exports